import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Formik } from 'formik'

import BaseModal from 'components/Modals/BaseModal'
import { closeModal } from 'store/actions/modals'
import { updateSetting } from 'store/actions/settings'
import { Button, DateTimePicker, Form } from 'components/Forms'

const PunchLockDateModal = () => {
  const dispatch = useDispatch()
  const { punchCardLockDate } = useSelector(state => state.settings)

  return (
    <BaseModal hideButtons title={`manager.punch.PUNCH_LOCK_DATE_MODAL`}>
      <Formik
        enableReinitialize={true}
        initialValues={{ punchCardLockDate }}
        onSubmit={values => {
          // Update the company setting for punch card lock date
          dispatch(updateSetting('punchCardLockDate', values.punchCardLockDate, null, true))
          dispatch(closeModal())
        }}
      >
        {({ isSubmitting, dirty }) => (
          <Form className="mt-2" dirty={!!dirty && !isSubmitting}>
            <DateTimePicker module="manager.punch.PUNCH_LOCK_DATE_MODAL" name="punchCardLockDate" type="date" isClearable />
            <Button className="btn btn-primary mr-2" type="submit" isSubmitting={isSubmitting} text="SUBMIT" />
            <Button className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} text="actions.CLOSE" />
          </Form>
        )}
      </Formik>
    </BaseModal>
  )
}

export default PunchLockDateModal
